<template>
<article class="message is-info">
  <div class="message-body">
    Tools are provided without warranty or support. The files generated
    are intended for use during testing only and should not be used in a
    production environment.
  </div>
</article>
</template>
